import { render, staticRenderFns } from "./modalUpdateInfo.vue?vue&type=template&id=024bec57"
import script from "./modalUpdateInfo.vue?vue&type=script&lang=js"
export * from "./modalUpdateInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports